import React, { Component, PropTypes } from 'react';
import { TimePickerField, BootstrapSelect } from '../Inputs';
import moment from 'moment';

export default class SchedulePicker extends Component {
	static PropTypes = {
		val : PropTypes.string,
		label : PropTypes.string,
		id : PropTypes.string,
		start_time : PropTypes.any,
        end_time : PropTypes.any
	};

	state = {
        days: [
            {
                value: '',
                label: 'Select a day',
                disabled: false
            }, {
                value: 0,
                label: 'Sunday',
                disabled: false
            }, {
                value: 1,
                label: 'Monday',
                disabled: false
            }, {
                value: 2,
                label: 'Tuesday',
                disabled: false
            }, {
                value: 3,
                label: 'Wednesday',
                disabled: false
            }, {
                value: 4,
                label: 'Thursday',
                disabled: false
            }, {
                value: 5,
                label: 'Friday',
                disabled: false
            }, {
                value: 6,
                label: 'Saturday',
                disabled: false
            },  
        ],
		val : '',
		start_time: '',
        end_time: ''
	};

	handleDay = (e) => {
		this.setState({
			val : e.target.value
		},() => {
			this.props.updateScheduleArray(this.props.index, this.state.val, this.state.start_time, this.state.end_time);
            this.props.updateDays();
		});
	};

	handleStartTime = (e) => {
		this.setState({
			start_time : e
		},() => {
			this.props.updateScheduleArray(this.props.index, this.state.val, this.state.start_time, this.state.end_time);
		});
	};

    handleEndTime = (e) => {
        this.setState({
            end_time: e
        },() => {
            this.props.updateScheduleArray(this.props.index, this.state.val, this.state.start_time, this.state.end_time);
        });
    };

	componentDidMount() {
        let start_time = moment().format('hh:mm A');
        let end_time = moment().add(15, 'minutes').format('hh:mm A');
		this.setState({
            days: this.props.days,
			val : this.props.val,
			start_time : this.props.startTime ? this.props.startTime : start_time,
            end_time : this.props.endTime ? this.props.endTime : end_time
		}, () => {
            this.props.updateDays();
        })
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
            days: nextProps.days,
			val : nextProps.val,
			start_time : nextProps.startTime,
            end_time : nextProps.endTime
		})
	}

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

	render () {

		let buttonColor = "red removeSchedule"
		let buttonClass = 'fa fa-times removeSchedule';

		if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue addSchedule";
            buttonClass = 'fa fa-plus addSchedule';
        }

		return (
			<div className="form-group form-md-line-input form-md-floating-label perContainer">
                <div className="row">
                    <div className="col-md-5">
                        <BootstrapSelect id={'day'+this.props.index} label="Day of week"
                             help="Select a day..."
                             val={this.state.val}
                             onChange={this.handleDay}
                             options={this.state.days} />
                    </div>
                    <div className="col-md-3">
                        <TimePickerField id={'schedule_start_time'+this.props.index} label="Start Time"
                                     help="Select opening time..."
                                     onChange={this.handleStartTime}
                                     val={this.state.start_time}
                                     adjustMinutes={0}
                                     updateTime={this.state.start_time} />
                    </div>
                    <div className="col-md-3">
                        <TimePickerField id={'schedule_end_time'+this.props.index} label="End Time"
                                     help="Select closing time..."
                                     onChange={this.handleEndTime}
                                     val={this.state.end_time}
                                     adjustMinutes={15}
                                     updateTime={this.state.end_time} />
                    </div>
                    <div className="col-md-1" style={{marginTop: '20px'}}>
                        <span className="input-group-btn btn-right">
                            <a href="#" className={"btn btn-circle btn-icon-only " + buttonColor} >
                                <i className={buttonClass}></i>
                            </a>
                        </span>
                    </div>
                </div>
			</div>
		)
	}

}



/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/SchedulePicker.js
 **/